import { TypographyComponent } from "@gx1/gx-npm-ui";
import { useTranslation } from "react-i18next";
import styles from "./view-only-badge.styles.module.scss";
import { EyeOutlineIcon } from "./eye-outline.icon";

const ViewOnlyBadgeComponent = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.badgeWrapper}>
      <EyeOutlineIcon />
      <TypographyComponent boldness="regular" element="span" rootClassName={styles.badgeText} styling="p3">
        {t("View Only")}
      </TypographyComponent>
    </div>
  );
};

export default ViewOnlyBadgeComponent;
